import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoWarningCircle = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>WarningCircle</title>
    <path
      d="M4.275 16.997c0-7.024 5.694-12.718 12.718-12.718S29.71 9.973 29.71 16.997s-5.694 12.718-12.718 12.718S4.275 24.021 4.275 16.997ZM16.992 9.628v8.783"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path stroke="currentColor" strokeWidth={2.5} strokeLinejoin="round" d="M17 23h.01v.01H17z" />
  </svg>
);
export default SvgIcoWarningCircle;
